import { Injectable } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';

import { Cifrado } from '../../libraries/cifrado/cifrado';
import { Constantes } from '../../system/constantes/constantes';
import { GVars } from '../../system/gvars/gvars';
import { KnCloudRestApiService } from 'src/app/services/kncloud-rest-api/kncloud-rest-api.service';
import { Notificaciones } from '../../system/notificaciones/notificaciones';
import { Router } from '@angular/router';

@Injectable()
export class LoginController 
{
  private idUnico: string = '';
  private loadingMostrado: boolean = false;  
  private loginMostrado: boolean = false;

  public loginComponent: any = null;
  
  constructor(
    private loadingController : LoadingController,
    private modalController   : ModalController,
    private router            : Router, 
    private knCloudRestApi    : KnCloudRestApiService,
    private errores           : Notificaciones,
    private cifrado           : Cifrado,
    private constantes        : Constantes,
    private gVars             : GVars
    ) 
  {
  }

  obtenerIdUnico()
  {
    this.idUnico = this.obtenerCookie(this.constantes.COOKIE_UUID);
    if('' == this.idUnico)
    {
      this.idUnico = new Date().valueOf().toString();
      this.guardarCookie(this.constantes.COOKIE_UUID, this.idUnico, this.constantes.COOKIE_DURACION_DIAS);
    }    
  }

  guardarCookie(cname: string, cvalue: string , exdays: number) 
  {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  obtenerCookie(cname: string) 
  {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  eliminarCookie(cname: string) 
  {
    var d = new Date();
    d.setTime(d.getTime() - (1*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=;" + expires + ";path=/";
  }

  ejecutarLoginAutomatico()
  {    
    let datosSesionObtenidos = this.obtenerDatosSesion();
    //console.log('datosSesionObtenidos: "'+ datosSesionObtenidos + '"');
    datosSesionObtenidos = datosSesionObtenidos.replace(/%2F/g, '/');
    if(undefined != datosSesionObtenidos && '' != datosSesionObtenidos)
    {
      let datosSesion = this.cifrado.desencriptar(datosSesionObtenidos).split("|");
      //console.log('datosSesion: ' + datosSesion);
      //console.log(datosSesion[0]);
      //console.log(datosSesion[1]);
      this.ejecutarLogin(datosSesion[0], datosSesion[1], false, false, false);
    }
    this.gVars.aplicacionCargada = true;
  }

  ejecutarLogin(email: string, password: string, recordarSesion: boolean, ocultarLogin: boolean, mostrarLoading: boolean = true)
  {    
    if(mostrarLoading)
    {
      this.mostrarLoading('Iniciando sesión . . .');
    }
    
    this.knCloudRestApi.obtenerUsuario(email).subscribe((response: any) => 
    {      
      if(undefined != response)         
      {
        //console.log(response);
        if(undefined != response.resultado)
        {
          if(this.errores.ID_SUCCESS == response.resultado.codigo)
          {                        
            if(null != response.usuario)
            {
              let passwordMd5: string = password;            
              if(!this.cifrado.esUnaCadenaMd5(password))
              {
                passwordMd5 = this.cifrado.generarMd5(password);
              }            
              //console.log(passwordMd5);
              //console.log(response.usuario.password);
              if(passwordMd5 == response.usuario.password)
              {                                          
                this.gVars.usuario  = response.usuario;
                this.gVars.usuarioLogueado = true;
                //console.log(this.gVars.usuario);                
            
                if(recordarSesion)
                {                
                  this.guardarDatosSesion(email, passwordMd5);          
                }

                if(ocultarLogin)
                {
                  this.modalController.dismiss({});
                }                
              }
              else
              {
                this.errores.mostrarError(this.errores.ID_ERR_USUARIO_PASSWORD);
              }
            }
          }
          else
          {        
            this.errores.mostrarError(this.errores.ID_ERR_USUARIO_PASSWORD);
          }
        }
      }
      
      if(mostrarLoading)
      {
        this.ocultarLoading();
      }      
    },
    (err) => 
    {
      if(mostrarLoading)
      {
        this.ocultarLoading();
      }
      console.log(err);
    });
  }

  guardarDatosSesion(email: string, password: string)
  {
    this.obtenerIdUnico();
    //console.log('idUnico: ' + this.idUnico);
    if(this.idUnico != '')
    {
      let datosSesion = this.cifrado.encriptar(email + '|' + password + '|');
      datosSesion = encodeURIComponent(datosSesion);
      datosSesion = datosSesion.replace(/%2F/g, '%252F');
      datosSesion = datosSesion.replace(/%25F/g, '%252F');
      datosSesion = datosSesion.replace(/%3D/g, '=');
      datosSesion = datosSesion.replace(/%2B/g, '+');
      //console.log(datosSesion);
      this.guardarCookie(this.idUnico, datosSesion, this.constantes.COOKIE_DURACION_DIAS);
    }
  }

  obtenerDatosSesion()
  {
    let ret: string = '';
    this.obtenerIdUnico();
    if(this.idUnico != '')    
    {
      ret = this.obtenerCookie(this.idUnico);
    }

    return ret;
  }

  private async mostrarLoading(mensaje: string) 
  {
    this.loadingMostrado = true;
    const loading = await this.loadingController.create({
      message: mensaje
    });    
    return await loading.present();
  }

  private ocultarLoading() 
  {
    setTimeout(() => 
    {
      if(this.loadingMostrado) 
      {
        this.loadingMostrado = false;
        return this.loadingController.dismiss();
      }
    }, 750);
  }

  cerrarSesion()
  {
    this.mostrarLoading('Cerrando sesión . . .')
    setTimeout(() => 
    {
      this.eliminarCookie(this.idUnico);
      this.gVars.usuario = null;
      this.gVars.usuarioLogueado = false;
      this.router.navigate(['/']);
      this.ocultarLoading();
    }, 1000);
  }
}